import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrderIncomeReceiptReport  {
    _originalTypeClassName = "zERP.BO.PaymentOrderIncomeReceiptReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrderIncomeReceiptReport.translate = translateService;
}
this.OurIncomeReceipts = [];
this.OurPaymentOrders = [];
this.ThirdPartyIncomeReceipts = [];
this.ThirdPartyPaymentOrders = [];
this.BusinessEntityName = null;
this.BusinessEntityShortName = null;
this.DateCreated = null;
this.IncomeReceiptsTotalAmount = null;
this.PaymentOrdersTotalAmount = null;
this.PaymentOrderIncomeReceiptReportKey = null;
this._key = this.PaymentOrderIncomeReceiptReportKey = 0; 
}

static translate: TranslateService;
_key: any;
BusinessEntityName:any;
BusinessEntityShortName:any;
DateCreated:any;
IncomeReceiptsTotalAmount:any;
PaymentOrdersTotalAmount:any;
OurIncomeReceipts:any;
OurPaymentOrders:any;
ThirdPartyIncomeReceipts:any;
ThirdPartyPaymentOrders:any;
OurIncomeReceiptsTotals:any;
OurPaymentOrdersTotals:any;
ThirdPartyIncomeReceiptsTotals:any;
ThirdPartyPaymentOrdersTotals:any;
private _PaymentOrderIncomeReceiptReportKey:any;
get PaymentOrderIncomeReceiptReportKey(): any {
    return this._PaymentOrderIncomeReceiptReportKey;
  }
set PaymentOrderIncomeReceiptReportKey(value: any) {
    this._PaymentOrderIncomeReceiptReportKey = value;
    this._key = value;
  }
static setOurIncomeReceipts = ($this, items) => {
                if (items == null) items = [];
                if ($this.OurIncomeReceipts == null) $this.OurIncomeReceipts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OurIncomeReceipts.length > 0) {
                    Domain.PaymentOrderIncomeReceiptReport.removeOurIncomeReceipts($this, $this.OurIncomeReceipts[0]);
                }

                Domain.PaymentOrderIncomeReceiptReport.addManyOurIncomeReceipts($this, copyItems);
            }
static addManyOurIncomeReceipts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrderIncomeReceiptReport.addOurIncomeReceipts($this, items[i]);
                }
            }
static addOurIncomeReceipts = ($this, item) => {
                if ($this.OurIncomeReceipts == null) $this.OurIncomeReceipts = [];
                if (item == null || $this.OurIncomeReceipts.indexOf(item) > -1) return;
                $this.OurIncomeReceipts.push(item);
}
static addRangeOurIncomeReceipts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrderIncomeReceiptReport.addOurIncomeReceipts($this, item));
            }
static removeOurIncomeReceipts = ($this, item) => {
                if ($this == null || $this.OurIncomeReceipts == null || $this.OurIncomeReceipts.indexOf(item) === -1) return;
                var _index = $this.OurIncomeReceipts.indexOf(item);
                $this.OurIncomeReceipts.splice(_index, 1);
}
static clearOurIncomeReceipts = ($this) => { $this.OurIncomeReceipts = null; }
static setOurPaymentOrders = ($this, items) => {
                if (items == null) items = [];
                if ($this.OurPaymentOrders == null) $this.OurPaymentOrders = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OurPaymentOrders.length > 0) {
                    Domain.PaymentOrderIncomeReceiptReport.removeOurPaymentOrders($this, $this.OurPaymentOrders[0]);
                }

                Domain.PaymentOrderIncomeReceiptReport.addManyOurPaymentOrders($this, copyItems);
            }
static addManyOurPaymentOrders = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrderIncomeReceiptReport.addOurPaymentOrders($this, items[i]);
                }
            }
static addOurPaymentOrders = ($this, item) => {
                if ($this.OurPaymentOrders == null) $this.OurPaymentOrders = [];
                if (item == null || $this.OurPaymentOrders.indexOf(item) > -1) return;
                $this.OurPaymentOrders.push(item);
}
static addRangeOurPaymentOrders = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrderIncomeReceiptReport.addOurPaymentOrders($this, item));
            }
static removeOurPaymentOrders = ($this, item) => {
                if ($this == null || $this.OurPaymentOrders == null || $this.OurPaymentOrders.indexOf(item) === -1) return;
                var _index = $this.OurPaymentOrders.indexOf(item);
                $this.OurPaymentOrders.splice(_index, 1);
}
static clearOurPaymentOrders = ($this) => { $this.OurPaymentOrders = null; }
static setThirdPartyIncomeReceipts = ($this, items) => {
                if (items == null) items = [];
                if ($this.ThirdPartyIncomeReceipts == null) $this.ThirdPartyIncomeReceipts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ThirdPartyIncomeReceipts.length > 0) {
                    Domain.PaymentOrderIncomeReceiptReport.removeThirdPartyIncomeReceipts($this, $this.ThirdPartyIncomeReceipts[0]);
                }

                Domain.PaymentOrderIncomeReceiptReport.addManyThirdPartyIncomeReceipts($this, copyItems);
            }
static addManyThirdPartyIncomeReceipts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrderIncomeReceiptReport.addThirdPartyIncomeReceipts($this, items[i]);
                }
            }
static addThirdPartyIncomeReceipts = ($this, item) => {
                if ($this.ThirdPartyIncomeReceipts == null) $this.ThirdPartyIncomeReceipts = [];
                if (item == null || $this.ThirdPartyIncomeReceipts.indexOf(item) > -1) return;
                $this.ThirdPartyIncomeReceipts.push(item);
}
static addRangeThirdPartyIncomeReceipts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrderIncomeReceiptReport.addThirdPartyIncomeReceipts($this, item));
            }
static removeThirdPartyIncomeReceipts = ($this, item) => {
                if ($this == null || $this.ThirdPartyIncomeReceipts == null || $this.ThirdPartyIncomeReceipts.indexOf(item) === -1) return;
                var _index = $this.ThirdPartyIncomeReceipts.indexOf(item);
                $this.ThirdPartyIncomeReceipts.splice(_index, 1);
}
static clearThirdPartyIncomeReceipts = ($this) => { $this.ThirdPartyIncomeReceipts = null; }
static setThirdPartyPaymentOrders = ($this, items) => {
                if (items == null) items = [];
                if ($this.ThirdPartyPaymentOrders == null) $this.ThirdPartyPaymentOrders = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ThirdPartyPaymentOrders.length > 0) {
                    Domain.PaymentOrderIncomeReceiptReport.removeThirdPartyPaymentOrders($this, $this.ThirdPartyPaymentOrders[0]);
                }

                Domain.PaymentOrderIncomeReceiptReport.addManyThirdPartyPaymentOrders($this, copyItems);
            }
static addManyThirdPartyPaymentOrders = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrderIncomeReceiptReport.addThirdPartyPaymentOrders($this, items[i]);
                }
            }
static addThirdPartyPaymentOrders = ($this, item) => {
                if ($this.ThirdPartyPaymentOrders == null) $this.ThirdPartyPaymentOrders = [];
                if (item == null || $this.ThirdPartyPaymentOrders.indexOf(item) > -1) return;
                $this.ThirdPartyPaymentOrders.push(item);
}
static addRangeThirdPartyPaymentOrders = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrderIncomeReceiptReport.addThirdPartyPaymentOrders($this, item));
            }
static removeThirdPartyPaymentOrders = ($this, item) => {
                if ($this == null || $this.ThirdPartyPaymentOrders == null || $this.ThirdPartyPaymentOrders.indexOf(item) === -1) return;
                var _index = $this.ThirdPartyPaymentOrders.indexOf(item);
                $this.ThirdPartyPaymentOrders.splice(_index, 1);
}
static clearThirdPartyPaymentOrders = ($this) => { $this.ThirdPartyPaymentOrders = null; }
static setOurIncomeReceiptsTotals = ($this, value) => {
var oldValue = $this.OurIncomeReceiptsTotals;
$this.OurIncomeReceiptsTotals = value;
if (value != null) {
}
}
static setOurPaymentOrdersTotals = ($this, value) => {
var oldValue = $this.OurPaymentOrdersTotals;
$this.OurPaymentOrdersTotals = value;
if (value != null) {
}
}
static setThirdPartyIncomeReceiptsTotals = ($this, value) => {
var oldValue = $this.ThirdPartyIncomeReceiptsTotals;
$this.ThirdPartyIncomeReceiptsTotals = value;
if (value != null) {
}
}
static setThirdPartyPaymentOrdersTotals = ($this, value) => {
var oldValue = $this.ThirdPartyPaymentOrdersTotals;
$this.ThirdPartyPaymentOrdersTotals = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PaymentOrderIncomeReceiptReportKey == null || $this.PaymentOrderIncomeReceiptReportKey == 0;
            }


}